export const REACT_APP_WATCH_SHARED_DATA = '__WATCH_SHARED_DATA__';
export const REACT_APP_MAIN_SCRIPT_TRIGGER = '$$__AC_WATCH_MAIN_TRIGGER_FUNCTION__$$';
